import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import ApiKeysCreate from './ApiKeysCreate';
import ApiKeysCreateModalSuccess from './ApiKeysCreateModalSuccess';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { clearApiKeyToken } from 'store/actions/apiKeys/deleteApiKeys';
import { connect } from 'react-redux';
import { createApiKey, createApiKeyModalSuccess } from 'store/actions/apiKeys/createApiKeys';
import { closeModal, openAlertModal } from 'store/actions/modalActions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';

class ApiKeysCreateContainer extends React.Component {
    constructor() {
        super();

        this.state = {
            error: null,
        };
    }

    handleModalClosed = () => {
        const {
            dispatchClearToken,
            history,
        } = this.props;

        dispatchClearToken();

        history.push('/api-keys');
    }

    handleSubmitForm = (values) => {
        const {
            dispatchShowModalFailure,
            dispatchShowModalSuccess,
            dispatchCloseModal,
            dispatchForm,
            translate,
        } = this.props;

        return new Promise((resolve) => {
            dispatchForm({
                callback: (error) => {
                    if (error) {
                        if (error.response.message === 'application-creation-exceeded') {
                            dispatchShowModalFailure({
                                actions: {
                                    submit: () => {
                                        dispatchCloseModal();

                                        this.handleModalClosed();
                                    },
                                },
                                content: {
                                    description: translate('resources.api-keys.error.description'),
                                },
                                title: translate('resources.api-keys.error.title'),
                            });
                        }

                        // This location should have where we bounce the error back to the form with SubmissionError.
                        resolve();
                    }

                    resolve(dispatchShowModalSuccess());
                },
                values: values,
            });
        });
    }

    render() {
        const {
            created,
            translate,
        } = this.props;

        const breadcrumbs = [
            {
                label: translate('menu.sidebar.api-keys'),
                link: '/api-keys',
            },
            {
                label: translate('actions.create'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.api-keys.actions.create') } />

                    <Actions>
                        <ListButton url='/api-keys' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <ApiKeysCreate
                            form='api_keys_create'
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>

                { !utils.isEmpty(created) &&
                    <ApiKeysCreateModalSuccess
                        data={ created }
                        handleSubmit={ this.handleModalClosed }
                    />
                }
            </div>
        );
    }
}

ApiKeysCreateContainer.propTypes = {
    created: PropTypes.object,
    dispatchClearToken: PropTypes.func.isRequired,
    dispatchForm: PropTypes.func.isRequired,
    dispatchCloseModal: PropTypes.func.isRequired,
    dispatchShowModalFailure: PropTypes.func.isRequired,
    dispatchShowModalSuccess: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    return {
        created: state['api-keys'].created,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchClearToken: () => {
            dispatch(clearApiKeyToken());
        },
        dispatchForm: (values) => {
            dispatch(createApiKey(values));
        },
        dispatchShowModalSuccess: () => {
            dispatch(createApiKeyModalSuccess());
        },
        dispatchShowModalFailure: (payload) => {
            dispatch(openAlertModal(payload));
        },
        dispatchCloseModal: () => {
            dispatch(closeModal());
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(ApiKeysCreateContainer);



// WEBPACK FOOTER //
// ./src/pages/api-keys/create/ApiKeysCreateContainer.js